import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { hasLineItemAmountTotalMismatch as getHasLineItemAmountTotalMismatch } from '@/utils/amount.util';

export default function useLineItemAmountValidation() {
  const { t } = useTranslation();

  const hasLineItemAmountTotalMismatch = useCallback(
    (lineItems, paymentAmount) =>
      getHasLineItemAmountTotalMismatch(lineItems, paymentAmount),
    [],
  );

  return {
    hasLineItemAmountTotalMismatch,
    lineItemAmountTotalMismatchMessage: t(
      'lineItems.errors.amountTotalMismatch',
    ),
  };
}
